import React, { Component } from "react";
import BlogPost from "./BlogPost";
import axios from "axios";

class Blog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			events: []
		};

		let blogId = "1808536030231193392";
		let apiKey = "AIzaSyCzlc3c_lHNrg6cM2hFon-fbGnunENMKVo";
		let url = "https://www.googleapis.com/blogger/v3/blogs/" + blogId + "/posts?key=" + apiKey;
		let self = this;
		axios.get(url)
			.then(res => {
				// Blogger returns `published` as an ISO date string; sort newest first
				// so the freshest post is the featured entry at the top.
				const items = (res.data.items || []).slice().sort((a, b) =>
					new Date(b.published) - new Date(a.published)
				);
				self.setState({
					events: items
				});
			});
	}

	render() {
		return (
			<div className="nf-entries">
				{this.state && this.state.events.length > 0 &&
					this.state.events.map((event, index) => (
						<BlogPost isOldPost={index !== 0} key={event.id} event={event} />
					))}
			</div>
		);
	}
}

export default Blog;
